var addURLParam = function addURLParam(base, param, value) {
  var paramStartIndex = base.indexOf('?');
  if (paramStartIndex !== -1) {
    var newParams = [];
    var params = base.slice(paramStartIndex + 1).split('&').filter(Boolean);
    var existingParam = "".concat(param, "=");
    var hasReplaced = false;
    params.forEach(function (p) {
      if (p.indexOf(existingParam) === 0) {
        newParams.push(existingParam + value);
        hasReplaced = true;
      } else {
        newParams.push(p);
      }
    });
    var result = base.slice(0, paramStartIndex);
    if (newParams.length) {
      result += "?".concat(newParams.join('&'));
    }
    if (!hasReplaced) {
      var _prefix = newParams.length ? '&' : '?';
      result += _prefix + existingParam + value;
    }
    return result;
  }
  var prefix = paramStartIndex === base.length - 1 ? '' : '?';
  return "".concat(base + prefix + param, "=").concat(value);
};

export { addURLParam };
//# sourceMappingURL=addURLParam.js.map
